namespace GeniuzPOS.Inventory {
    export class IcStockSkuColumns {
        static columnsKey = 'Inventory.IcStockSku';
    }
}
